function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,16c-1,0-1.9,0.4-2.7,1l-5.6-3.7C7.9,12.9,8,12.5,8,12s-0.1-0.9-0.2-1.3L13.3,7C14.1,7.6,15,8,16,8c2.2,0,4-1.8,4-4 s-1.8-4-4-4s-4,1.8-4,4c0,0.5,0.1,0.9,0.2,1.3L6.7,9C5.9,8.4,5,8,4,8c-2.2,0-4,1.8-4,4s1.8,4,4,4c1,0,1.9-0.4,2.7-1l5.6,3.7 C12.1,19.1,12,19.5,12,20c0,2.2,1.8,4,4,4s4-1.8,4-4S18.2,16,16,16z M16,2c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S14.9,2,16,2z  M4,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S5.1,14,4,14z M16,22c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,22,16,22z"
});

var SvgPhotoShare = function SvgPhotoShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 24",
    style: {
      enableBackground: "new 0 0 20 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-share.8ca2f2b4.svg";
export { ForwardRef as ReactComponent };